<template>
  <div id="app">
    <div class="outer">
      <ul class="skin">
        <li v-for="skin in skins" :key="skin.title"
         :class="[{current:skin.isActive}, skin.cla]"
         :title="skin.title"
         @click="handleChangeSkin(skin.cla)"
        >
          {{skin.value}}
        </li>
      </ul>
      <ul class="nav" :style="{background:activeColor}">
        <li v-for="(nav,index) in navs" :key="nav" :class="{last:index===navs.length-1}">
          <a href="#">{{nav}}</a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data:function(){
    return{
      activeColor:'green',
      activeBackground:'#a3c5a8',      
      skins:[
        {
          cla:'red',
          title:'红色',
          value:'red',
          isActive:false
        },
        {
          cla:'green',
          title:'绿色',
          value:'green',
          isActive:true
        },
        {
          cla:'black',
          title:'黑色',
          value:'black',
          isActive:false
        }
      ],
      navs:['新闻','娱乐','体育','电影','音乐','旅游']
    }
  },
  methods:{
    handleChangeSkin(val){
      switch(val){
        case "red":
        for(let i=0;i<this.skins.length;i++){
          this.skins[i].isActive=false;
        }
        for(let i=0;i<this.skins.length;i++){
          if(this.skins[i].cla===val){
            this.skins[i].isActive=true;
          }
        }
        document.body.style.background="#ffdddd";
        this.activeColor='red';
        break;

        case "green":
        for(let i=0;i<this.skins.length;i++){
          this.skins[i].isActive=false;
        }
        for(let i=0;i<this.skins.length;i++){
          if(this.skins[i].cla===val){
            this.skins[i].isActive=true;
          }
        }
        document.body.style.background=this.activeBackground;
        this.activeColor='green';
        break;

        case "black":
        for(let i=0;i<this.skins.length;i++){
          this.skins[i].isActive=false;
        }
        for(let i=0;i<this.skins.length;i++){
          if(this.skins[i].cla===val){
            this.skins[i].isActive=true;
          }
        }
        document.body.style.background="#cccccc";
        this.activeColor='black';
        break;
      }
    }
  }
}
</script>
<style>
body, ul, li{
  margin: 0;
  padding: 0;
}
html, body{
  height: 100%;
  background: #a3c5a8;
}
body{
  font: 12px/1.5 tahoma;
}
li{
  list-style: none;
}
a:link, a:visited{
  text-decoration: none;
}
a:hover{
  text-decoration: underline;
}
.outer{
  width: 500px;
  margin: 0 auto;
  overflow: hidden;
  zoom: 1;  
}
.skin, .nav{
  overflow: hidden;
  zoom: 1;
}
.skin{
  margin: 10px 0;
}
.skin li{
  float: left;
  width: 6px;
  height: 6px;
  cursor: pointer;
  overflow: hidden;
  margin-right: 10px;
  text-indent: -9999px;
  border-width: 4px;
  border-style: solid;
}
.skin li.current{
  background: #fff !important;
}
.red{
  border-color: red;
  background: red;
}
.green{
  border-color: green;
  background: green;
}
.black{
  border-color: black;
  background: black;
}
.nav{
  border: 1px solid #fff;
    background: green;

}
.nav li{
  float: left;
  width: 82px;
  line-height: 25px;
  text-align:center;
  border-right: 1px solid #fff;  
}
.nav li.last{
  width: 83px;
  border-right-width: 0;
}
.nav li a{
  color: #fff;
}
</style>
